import {useEffect, useState} from 'react';

import '../../dmView/style/App.css';
import InputEncounterId from './SideMenu/InputEncounterId.js';
import InputCharacterId from './SideMenu/InputCharacterId.js';
import DropdownMenu from './EncounterColumn/Dropdowns/DropdownMenu.js';
import SignIn from './SignIn.js';
import DmviewExample from '../../pics/demo/dmViewDemo2.png';

import PvExample from '../../pics/demo/playerviewdemo.PNG';
import TableViewExample from '../../pics/demo/tableviewdemo.PNG';

import questionMark from '../pics/icons/questionMark.png'
import Patreon from '../pics/patreon_logo.png'
import Discord from '../pics/icons/discord.png'

const Home = ({connectedToServer, savedEncounters, setSavedEncounters, currentEncounter, setCurrentEncounter, encounterGuid, handleNewEncounter, handleLoadEncounter, addNewHomebrew, socket}) => {
    const [notConnectedMessage, setNotConnectedMessage] = useState('🟡 Server Not Connected')

    useEffect(() => {
        setTimeout(() => {
            setNotConnectedMessage('🔴 Server Not Connected || Right Click → Inspect → Console Tab → Scroll to top of logs || Send a Screenshot to Dmbuddy Nic on Discord')
        }, 10000)
    })

    const homePageHomeBrew = () => {
        handleNewEncounter()
        addNewHomebrew(null, 'homepage')
        
    }

    return (
        <div className='firstLoadMenuContainer'>
            <span className='connectedDiv'><i>{connectedToServer ? '🟢 Server Connected' : notConnectedMessage}</i></span>
            <div className='firstLoadMenu'>
                <div className='homepageTopContent'>
                    <h1>DmBuddy.com</h1>
                    <span className='firstLoadExtra'>
                        Home Brew Focused Encounter Builder and Player View
                    </span>
                    <span className='firstLoadExtra'>
                        (with Dnd Beyond Importing)
                    </span>
                </div>

                <div className="homePageGrid">
                    <div className="gridCell largeCell">
                        <SignIn socket={socket}/>
                    </div>
                    <div className="gridCell dropDownHomePage">
                        <DropdownMenu 
                            setSavedEncounters={setSavedEncounters} 
                            savedEncounters={savedEncounters} 
                            handleLoadEncounter={handleLoadEncounter} 
                            currentEncounter={currentEncounter} 
                            setCurrentEncounter={setCurrentEncounter}
                            socket={socket} 
                        />
                    </div>
                    <div className="gridCell">
                        <InputCharacterId 
                            setCurrentEncounter={setCurrentEncounter} 
                            encounterGuid={encounterGuid} 
                            socket={socket} 
                        />
                    </div>
                    <div className="gridCell" style={{display: 'flex', flexDirection: 'row', gap: '12px'}}>
                        <button className='homePageButton' onClick={homePageHomeBrew} > Create Homebrew </button>
                        <button className='homePageButton' onClick={handleNewEncounter} > Create Encounter </button>
                    </div>
                    <div className="gridCell">
                        <InputEncounterId 
                            setCurrentEncounter={setCurrentEncounter} 
                            encounterGuid={encounterGuid} 
                            socket={socket} 
                        />
                    </div>
                </div>
            </div>

            <div className='exampleImagesContainer'>
                <div className='exImageContainer' onClick={() => window.open('http://dmbuddy.com/playerView/Q279SKWECC', 'popupWindow', 'width=1200,height=800,left=0,top=100')}>
                    <img className='exampleImage' src={PvExample} alt='Dmbuddy.com Playerview HUD Example Link' /> 
                    <span className='exampleImageText'>Player View</span>
                    <span className='exampleImageText extraText'>Upload Backgrounds - Custom Portraits - Paint a picture with the PlayerView!  </span>
                </div>
                <div className='exImageContainer' onClick={handleNewEncounter}>
                    <img className='exampleImage' src={DmviewExample} alt='DmView Exmaple' /> 
                    <span className='exampleImageText'>DM View</span>
                    <span className='exampleImageText extraText'>Create Encounters - Homebrew - DndBeyond Imports and More! </span>
                </div>
                <div className='exImageContainer' onClick={() => window.open('https://dmbuddy.com/playerView/C3DN3CYVU9/table', 'popupWindow', 'width=1200,height=800,left=0,top=100')}>
                    <img className='exampleImage' src={TableViewExample} alt='Dmbuddy.com Digital Table Playerview HUD Example Link' /> 
                    <span className='exampleImageText'>Player View: Digital Table </span>
                    <span className='exampleImageText extraText'>Detailed HUD For All Sides of the Table!</span>
                </div>
            </div>

            <div className='menuItemFirstPageContainer'>
                <a className='menuHelpLink' href='https://discord.gg/26TWEMqdka' target="_blank" rel="noreferrer"> 
                    <img src={Discord} alt="Dmbuddy.com Discord Link" className="menuIcon radius" /> 
                </a>
                
                <a className='menuHelpLink' href='/help' target="_blank" rel="noreferrer"> 
                    <img src={questionMark} alt="Dmbuddy.com Help Page Link" className="menuIcon radius" />
                </a>
                
                <a className='menuHelpLink' href='https://patreon.com/DmBuddy' target="_blank" rel="noreferrer"> 
                    <img src={Patreon} alt="Dmbuddy.com Patreon Link" className="menuIcon radius" />
                </a>
            </div>
        </div>
    );
};

export default Home;